<template>

  <div style="border: 1px solid #efefef; border-radius: 6px; padding: 20px 30px; margin: 20px 0">
    <div class="pull-right">

      <el-button-group>
      <router-link :to="{ name: 'FormFieldsEdit', params: { id: form._id } }" class="el-button el-button--default el-button--small">
        Edit fields
      </router-link>

      <router-link :to="{ name: 'FormPreview', params: { id: form._id } }" title="Preview form" class="el-button el-button--default el-button--small">
        <span class="el-icon-view"></span>
      </router-link>

      <el-button type="default" size="small" title="Edit form settings" @click="showFormSettings">
        <span class="el-icon-setting"></span>
      </el-button>

      <el-button type="default" size="small" title="Export submissions as CVS" @click="exportForm">
        <span class="el-icon-download"></span>
      </el-button>
      </el-button-group>

    </div>

    <form-icon :form="form" />

    <div class="form-title">{{form.title}}</div>

    <div class="form-description">{{form.description}}</div>

    <div class="clearfix" style="clear: both;"></div>

    <el-dialog title="Form settings" :visible.sync="showCreateForm">

      <settings-dialog :item="form" />

    </el-dialog>
  </div>

</template>

<script>
  import FormIcon from './Icon';
  import config from '../../../config'
  import SettingsDialog from './SettingsDialog';

  export default {
    components: {
      FormIcon,
      SettingsDialog
    },
    props: ['form'],
    data() {
      return {
        showCreateForm: false
      }
    },
    methods: {
      exportForm() {
        window.location.href = config.getApiUrl() + '/v1/forms-export/' + this.form._id;
      },
      showFormSettings() {
        this.showCreateForm = true;
      }
    }
  };
</script>



// WEBPACK FOOTER //
// Info.vue?e2c72074